import * as yup from "yup";

export const stockAdjustmentSchema = (messages: any) =>
  yup.object().shape({
    selectedCategoryIds: yup
      .array()
      .required()
      .min(
        1,
        messages[
          'specificationAttributes.validate.create.selectedCategoryIds'
        ].toString(),
      ),
    name: yup.string().required(messages['validation.name'].toString()),
  });